module.exports = __webpack_public_path__ + "media/images/icon-dial-icon-276ea041707514983be8b06c9cae140e.svg";